export const SUPPORT_EMAIL = 'support@kiao.com.tw'

/**
 * What the visitor is writing about: the contact form's topic picker and the
 * API's validator. A closed set rather than free text so the support inbox can
 * be filtered and routed, and so the subject line is predictable.
 */
export const CONTACT_TOPICS = ['product', 'billing', 'partnership', 'other'] as const
export type ContactTopic = (typeof CONTACT_TOPICS)[number]
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`

/**
 * Field length caps for the contact form, shared by the web form's `maxLength`
 * and the API's VineJS validator.
 *
 * Shared on purpose: when the two drifted, a 101-character name passed the form,
 * came back 422 from the API, and surfaced as a generic "something went wrong"
 * with no hint which field was too long — the visitor could only retry and fail
 * again.
 */
export const CONTACT_FIELD_LIMITS = {
  name: 100,
  email: 254,
  message: 3000,
} as const

/**
 * Gmail's "compose to" URL, used as the web fallback when `mailto:` leads
 * nowhere.
 *
 * A bare `mailto:` is only as good as the visitor's OS mail-handler config: on
 * Windows with no default mail app it opens the protocol chooser (picking a
 * browser navigates to the `mailto:` URL and renders a blank tab; picking an
 * unconfigured Outlook silently does nothing), and anyone living in webmail has
 * no handler registered at all. This URL needs nothing but a browser, so the
 * contact page always has a working path to a compose window.
 *
 * Built with `URLSearchParams` rather than string interpolation so the `@` in
 * the address is percent-encoded instead of sitting raw in the query string.
 */
export const SUPPORT_GMAIL_COMPOSE = `https://mail.google.com/mail/?${new URLSearchParams({
  view: 'cm',
  fs: '1',
  to: SUPPORT_EMAIL,
}).toString()}`
